<template>
  <a-layout :style="{ height: '100vh' }" class="home-wrapper">
    <a-layout-sider
      class="yd-left-sider"
      style="background: #fff"
      breakpoint="lg"
      collapsed-width="0"
    >
      <div class="logo-wrap">
        <div class="logo" />
      </div>
      <a-menu
        class="yd-menu"
        mode="inline"
        :default-selected-keys="[matchPath]"
        :open-keys="openKeys"
        @openChange="onOpenChange"
        @click="handleClick"
      >
        <a-sub-menu v-for="item in menuData" :key="item.id">
          <span slot="title">
            <img :src="item.icon" width="20px" height="20px" />
            {{ item.menuName }}
          </span>
          <a-menu-item v-for="item1 in item.children" :key="item1.path">
            {{ item1.menuName }}
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>
    <a-layout id="layoutContent" :style="{ position: 'relative' }">
      <a-layout-header
        :style="{
          background: '#0B8BFE',
          paddingRight: '50px',
          boxShadow: '0 4px 12px #0000001a',
        }"
      >
        <div :style="{ textAlign: 'right' }">
          <a-avatar :src="avatarUrl" />
          <div
            :style="{
              marginLeft: '10px',
              fontSize: '16px',
              display: 'inline-block',
            }"
          >
            <!-- 
            <span style="color:#212731;font-weight:500;">
              
              {{
                `欢迎你登录${
                  $store.state.user.role === 0 ? '企业' : '服务商'
                }，`
              }}
            </span>
            -->

            <span style="color: #fff">{{ companyName }}-{{ userName }}</span>
            <a-dropdown>
              <!-- <icon-font
                type="iconoperation"
                fill="red"
                style="cursor: pointer;filter: drop-shadow(red 80px 0);"
                
              /> -->

              <svg
                t="1700638412393"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3557"
                width="64"
                height="64"
                style="
                  width: 20px;
                  height: 20px;
                  margin-bottom: -4px;
                  cursor: pointer;
                "
              >
                <path
                  d="M512 298.6496a85.3504 85.3504 0 1 0 0-170.6496 85.3504 85.3504 0 0 0 0 170.6496z"
                  fill="#ffffff"
                  p-id="3558"
                ></path>
                <path
                  d="M512 512m-85.3504 0a85.3504 85.3504 0 1 0 170.7008 0 85.3504 85.3504 0 1 0-170.7008 0Z"
                  fill="#ffffff"
                  p-id="3559"
                ></path>
                <path
                  d="M512 896a85.3504 85.3504 0 1 0 0-170.7008 85.3504 85.3504 0 0 0 0 170.7008z"
                  fill="#ffffff"
                  p-id="3560"
                ></path>
              </svg>

              <a-menu slot="overlay" style="margin-top: 10px">
                <a-menu-item style="padding: 5px 40px 5px 10px">
                  <router-link to="/accountConfig"> 设置账号 </router-link>
                </a-menu-item>
                <a-menu-item style="padding: 5px 40px 5px 10px">
                  <router-link to="/password"> 修改密码 </router-link>
                </a-menu-item>
                <a-menu-item>
                  <a style="padding: 5px 40px 5px 10px" @click="handleLogout"
                    >退出账号</a
                  >
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
      </a-layout-header>
      <a-layout-content :style="{ padding: '0 38px' }">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
// import { menuData1, menuData2 } from './data/index';
export default {
  data() {
    return {
      menuData: [],
      avatarUrl: require("../assets/avatar.png"),
      // msgUrl: require('../assets/通知.png'),
      userName: "",
      companyName: "",
      openKeys: [],
    };
  },
  computed: {
    matchPath() {
      const path = this.$route.path;
      const matchPath = path.split("/")[1];
      return `/${matchPath}`;
    },
  },
  async mounted() {
    // 企业
    this.menuData = JSON.parse(localStorage.getItem("menuData"));
    // 用户名
    this.userName = localStorage.getItem("username");
    // 企业名称
    this.companyName = localStorage.getItem("companyName");
    const mathMenu = this.menuData.find((item) =>
      item.children.some((c) => c.path === this.matchPath)
    );

    if (mathMenu) {
      this.openKeys = [mathMenu.id];
    }
  },
  methods: {
    onOpenChange(openKeys) {
      this.openKeys = openKeys.slice(-1);
    },
    // 退出登录
    handleLogout() {
      localStorage.clear();
      this.$router.replace("/login");
    },
    handleClick(e) {
      this.$router.push(e.key);
    },
    // 点击消息
    handleMessage() {
      this.$router.push("/messages");
    },
  },
};
</script>

<style lang="scss">
.home-wrapper {
  .logo-wrap {
    height: 64px;
    padding: 16px;
    background: #0b8bfe;
    .logo {
      height: 40px;
      background: url("../assets/logo.png");
      background-size: 100% 100%;
    }
  }
}
.yd-menu {
  border-top: 1px solid rgba(239, 240, 247, 1);
  // .ant-menu-inline .ant-menu-item {
  //   width: calc(100% + 10px);
  //   padding-left: 40px !important;
  // }
  .ant-menu-item:hover {
    color: #0b8bfe;
  }
  .ant-menu-submenu-title:hover {
    color: #0b8bfe;
  }
  .ant-menu-submenu-inline
    > .ant-menu-submenu-title:hover
    .ant-menu-submenu-arrow::after {
    color: #0b8bfe;
    // background:transparent !important;
    // background: linear-gradient(
    //   to right,
    //   rgba(70, 211, 221, 1),
    //   rgba(70, 211, 221, 1)
    // );
  }
  // .ant-menu-submenu-inline
  //   > .ant-menu-submenu-title:hover
  //   .ant-menu-submenu-arrow::before {
  //   background: rgba(70, 211, 221, 1);
  // }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #edf9fb;
    border-radius: 0px 3px 3px 0px;
    color: #0b8bfe;
    z-index: 100;
    // border-left:solid 8px #0B8BFE;
    // padding-left: 40px !important;
  }
  .ant-menu-inline .ant-menu-item::after {
    border-right: none;
    position: absolute;
    top: 14px;
    bottom: 14px;
    right: 10px;
    width: 3px;
    // background: rgba(255, 255, 255, 1);
    border-radius: 1px;
  }
}
.yd-left-sider {
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 0px 7px 0px rgba(201, 225, 210, 0.35);
}

.select-default-collaborate .ant-select-selection--single {
  border-radius: 15px !important;
}
.ant-layout {
  background: #f3f8f8 !important;
}
.ant-menu-inline {
  border-right: none !important;
}
</style>
